import React from 'react';
import { GrowthBook, GrowthBookProvider as GBProvider } from '@growthbook/growthbook-react';

import { useEffect, ReactNode } from 'react';

const growthBook = new GrowthBook({
  apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.REACT_APP_STAGE !== 'prod',
});

function GrowthBookProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    growthBook.loadFeatures({ autoRefresh: true });
  }, []);

  useEffect(() => {
    growthBook.setAttributes({
      env: process.env.REACT_APP_STAGE,
    });
  }, []);

  return <GBProvider growthbook={growthBook}>{children}</GBProvider>;
}

export default GrowthBookProvider;
